<mat-toolbar [ngClass]="mode + '-modal-container'">
  <h1>{{ mode | titlecase }}</h1>
</mat-toolbar>
<mat-dialog-content>
  {{ message }}
</mat-dialog-content>
<mat-dialog-actions class="status-button-holder">
  <button
    mat-button
    [mat-dialog-close]="'OK'"
    color="basic"
    class="width-full">
    OK
  </button>
</mat-dialog-actions>
